import React from 'react'
import { FaFacebook, FaEnvelope, FaPhone } from 'react-icons/fa'

const footerLinks = [
  {
    path:
      'https://www.google.com/search?rlz=1C5CHFA_enMX849MX849&sxsrf=ALeKk00URiaJNCoLj4_q1K5H0DiJuRULOA:1602955114487&q=global+actuarial+services&npsic=0&rflfq=1&rlha=0&rllag=19408301,-99180203,259&tbm=lcl&ved=2ahUKEwjjjcKRkbzsAhVMgK0KHd5AC2wQtgN6BAgMEAc&rldoc=1#rlfi=hd:;si:16944010738829335289;mv:[[19.410755899999998,-99.17924599999999],[19.4058477,-99.1811606]]',
    text: 'Mapa',
    external: true,
  },
  {
    path: 'tel:5552734093',
    text: '5552734093',
    external: true,
  },
  {
    path: 'tel:5552722966',
    text: '5552722966',
    external: true,
  },
  {
    path: 'mailto:informes@actuarialservices.com.mx?subject=Contacto sitio web',
    text: 'informes@actuarialservices.com.mx',
    external: true,
  },
]

const footerNavigationLinks = [
  {
    text: 'Inicio',
    items: [
      {
        path: '/',
        text: 'Inicio',
      },
    ],
  },
  {
    text: 'Nosotros',
    items: [
      {
        path: '/nosotros',
        text: 'Nosotros',
      },
    ],
  },
  {
    text: 'Servicios',
    items: [
      {
        path: '/servicios',
        text: 'Consultoría actuarial',
      },
      {
        path: '/servicios',
        text: 'Consultoría en planes de beneficios',
      },
      {
        path: '/servicios',
        text: 'Asesoría patrimonial',
      },
      {
        path: '/servicios',
        text: 'Servicios adicionales',
      },
    ],
  },
  {
    text: 'Normatividad',
    items: [
      {
        path: '/normatividad',
        text: 'Gobierno',
      },
      {
        path: '/normatividad',
        text: 'Documentos actualizados',
      },
    ],
  },
  {
    text: 'Comunidad',
    items: [
      {
        path: '/blog',
        text: 'Blog',
      },
      {
        path: '/contacto',
        text: 'Contacto',
      },
    ],
  },
  {
    text: 'Localidades',
    items: [
      {
        text: 'CDMX',
      },
      {
        text: 'Guadalajara',
      },
      {
        text: 'Monterrey',
      },
      {
        text: 'Puebla',
      },
      {
        text: 'Querétaro',
      },
      {
        text: 'Mérida',
      },
    ],
  },
]

const navbarLinks = [
  {
    path: '/',
    text: 'Inicio',
  },
  {
    path: '/nosotros',
    text: 'Nosotros',
  },
  {
    path: '/servicios',
    text: 'Servicios',
  },
  {
    path: '/normatividad',
    text: 'Normatividad',
  },
  {
    path: '/blog',
    text: 'Blog',
  },
  {
    path: '/contacto',
    text: 'Contacto',
  },
]

const socialLinks = [
  {
    icon: <FaFacebook />,
    url: 'https://www.facebook.com/Global-Actuarial-Services-109956327095275/',
  },
  {
    icon: <FaEnvelope />,
    url: 'mailto:informes@actuarialservices.com.mx?subject=Contacto sitio web',
  },
  { icon: <FaPhone />, url: 'tel:5552734093' },
  { icon: <FaPhone />, url: 'tel:5552722966' },
]

export { footerLinks, socialLinks, navbarLinks, footerNavigationLinks }
